(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-images"]) return;
  try {
    
  $(document).ready(function(){
    productSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"]) return;
  try {
    
  var recommended_prods = $('.product-recommendations__products');
  function related_mobile() {
    if(typeof recommended_prods.slick !== 'undefined' && $('.product-recommendations__products').hasClass('.slick-initialized')) {
      if (window.matchMedia("(max-width: 767px)").matches) {
        recommended_prods.slick({
          infinite: true,
          arrows: true,
          prevArrow: $('#prevRelatedArrow'),
          nextArrow: $('#nextRelatedArrow')
        });
      } else {
        recommended_prods.slick('unslick');
      }
    }
  }
  $(document).ready(function(){
    related_mobile();
  })
  $(window).on('resize', function(){
    related_mobile();
  })

  } catch(e) { console.error(e); }
})();
})();
